/**
 * @desc 调拨发运
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/test/testDispatchByAoNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
